import Swiper from 'swiper';
import 'swiper/css';

// Function to initialize the Recently Viewed functionality
const initializeRecentlyViewed = () => {
  const recentlyViewedContainer = document.querySelector('.recently-viewed-swiper .swiper-wrapper');
  const recentlyViewedSection = document.querySelector('.recently-viewed-products');
  const recentlyViewedTitle = document.querySelector('.subhead-1');

  // Function to render recently viewed products into Swiper slides
  const renderRecentlyViewedProducts = () => {
    const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
    recentlyViewedContainer.innerHTML = '';

    // Only render if there are at least two items in the array (index 0 and 1)
    if (recentlyViewed.length <= 1) {
      recentlyViewedSection.classList.add('hidden');
      recentlyViewedTitle.classList.add('hidden');
      return;
    }

    // Remove 'hidden' class if there are products to display
    recentlyViewedSection.classList.remove('hidden');
    recentlyViewedTitle.classList.remove('hidden');

    // Render up to 4 products, starting from index 1 to ensure at least two items are needed
    for (let i = 1; i < 5; i += 1) {
      const product = recentlyViewed[i];
      if (product) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide mr-[10px] lg:mr-0';

        slide.innerHTML = `
          <a href="${product.url}" class="recently-viewed-link 
          no-underline flex flex-col" data-product-card>
            <div class="w-full aspect-w-1 aspect-h-1">
              <img src="${product.image || '/path/to/default/image.jpg'}" alt="${product.title || 'Unknown Product'}"
                class="recently-viewed-image 
                object-cover w-full h-full" loading="lazy">
            </div>
            <div class="flex flex-col gap-0.5 
            pt-3 pl-2.5 pr-1 lg:pt-4 lg:pr-0 lg:pl-0 lg:gap-1 text-left">
              <p class="recently-viewed-title
               product-card-name block w-full 
               text-black mt-3 mb-0 text-[17px]">
                ${product.title || 'Unknown Product'}
              </p>
              <p class="product-color product-card-description 
              block w-full text-secondary no-underline">
                ${product.color || 'Unknown Color'}
              </p>
              <p class="product-price">
                ${product.price ? `$${parseFloat(product.price).toFixed(0)}` : 'Unknown Price'}
              </p>
            </div>
          </a>
        `;

        recentlyViewedContainer.appendChild(slide);
      }
    }
  };

  // Initialize Swiper
  const initializeSwiper = () => {
    if (typeof Swiper !== 'undefined') {
      const swiperInstance = new Swiper('.recently-viewed-swiper', {
        slidesPerView: 2,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        },
        pagination: {
          el: '[data-recently-viewed-pagination]',
          clickable: true,
          bulletClass: 'w-4 h-0.5 mx-1 inline-block bg-gray-300',
          bulletActiveClass: 'bg-black',
        },
      });
      return swiperInstance;
    }
    return null; // Return null if Swiper is not defined
  };

  // Use MutationObserver to observe Swiper availability and initialize when ready
  const observer = new MutationObserver(() => {
    if (typeof Swiper !== 'undefined') {
      initializeSwiper();
      observer.disconnect(); // Stop observing once Swiper is initialized
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Render products and initialize swiper
  const initializeRendering = () => {
    renderRecentlyViewedProducts();
    initializeSwiper(); // Ensure Swiper is initialized after rendering
  };

  // Listen for the custom event and re-render when triggered
  window.addEventListener('recentlyViewedUpdated', initializeRendering);

  // Initial rendering
  initializeRendering();
};

// Attach the event listener for DOMContentLoaded to call the function
document.addEventListener('DOMContentLoaded', initializeRecentlyViewed);

// Export the main function at the bottom
export default initializeRecentlyViewed;